export function LogoMark({ size = 22 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <rect width="32" height="32" rx="9" fill="var(--ink)" />
      <rect x="7" y="9" width="11" height="8" rx="2.5" fill="var(--bg)" />
      <rect x="14" y="15" width="11" height="8" rx="2.5" fill="var(--ai)" />
    </svg>
  )
}

export function Logo() {
  return (
    <span className="inline-flex items-center gap-2">
      <LogoMark />
      <span className="text-[17px] font-semibold tracking-[-0.02em]">moot</span>
    </span>
  )
}
